export default {
  items: [
    {
      name: "Bank mobile users",
      url: "/auditor-users",
      icon: "fa fa-tablet fa-lg",
      attributes: { "data-cy": "auditor-users" },
    },
    {
      name: "Search mobile user",
      url: "/mobile-user-search",
      icon: "fa fa-search fa-lg",
      attributes: { "data-cy": "mobile-user-search" },
    },
    {
      name: "History",
      url: "/auditor-history",
      icon: "fa fa-history fa-lg",
      attributes: { "data-cy": "history" },
    },
  ],
};
